import React from "react";
import InvoiceDataSection from "./InvoiceDataSection";

const InvoiceDataSectionContainer = props => {
  return <InvoiceDataSection {...props} />;
};

export default InvoiceDataSectionContainer;
